export default class CollapseManager
{
    constructor(element)
    {
        this.element = element;
        this.eventDelegation();
    }

    eventDelegation()
    {
        this.element.querySelectorAll('[data-entity="collapse"] [data-collapse-toggle]').forEach((collapse) =>
        {
            if (collapse.classList.contains('collapse-initialized')) {
                return;
            }
            collapse.classList.add('collapse-initialized');
            collapse.addEventListener("click", (event) =>
            {
                const collapseToggleElement = event.currentTarget;
                const collapseId = collapseToggleElement.getAttribute('data-collapse-toggle');
                const collapseElement = collapseToggleElement.closest('[data-entity="collapse"]');
                const collapseContent = collapseElement.querySelector('[data-collapse-content="' + collapseId + '"]');

                if (collapseElement.classList.contains('collapsed')) {
                    collapseContent.style.maxHeight = collapseContent.scrollHeight + "px";

                    let collapseContentParent = collapseElement.closest('.collapse-content');
                    if (collapseContentParent) {
                        collapseContentParent.style.maxHeight = (collapseContent.scrollHeight + collapseContentParent.scrollHeight) + "px";
                    }
                } else {
                    collapseContent.style.maxHeight = null;
                }
                collapseElement.classList.toggle('collapsed');
            });
        });
    }
}
